import request from '@/utils/request'

export const getClassesList = ({ page, size, keywords: classesName }) => {
  return request({
    url: `/trace/classes/${page}/${size}`,
    params: {
      classesName
    }
  })
}

export const postClassesEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/classes',
    data
  })
}

export const putClassesAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/classes',
    data
  })
}

export const getClassesDetail = ({ id }) => {
  return request({
    url: `/trace/classes/${id}`
  })
}

export const deleteClassesDel = ({ id }) => {
  return request({
    method: 'delete',
    url: `/trace/classes/${id}`
  })
}

export const delClassesList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/classes/all',
    data
  })
}
